'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
		},
		templateUrl: `./${BUILD_PATH}/header-admin-elements.directive.html`,
		controller: /* @ngInject */ function ($scope) {
		}
	};
}
